import React from "react";
import { useTranslation } from "react-i18next";
import { Textarea } from "../UI/FormField";

interface Props {
  value: string;
  onChange: (value: string) => void;
  readonly?: boolean;
}

export const TaskFormRemarks: React.FC<Props> = ({ value, onChange, readonly }) => {
  const { t } = useTranslation("tasks");

  if (readonly) {
    return (
      <p className="text-[13px] text-gray-700 whitespace-pre-wrap min-h-[2rem] leading-relaxed">
        {value || <span className="text-gray-400">{t("form.remarksPlaceholder")}</span>}
      </p>
    );
  }

  return (
    <Textarea
      size="sm"
      rows={3}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={t("form.remarksPlaceholder")}
    />
  );
};
